import { Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";

export const AdminLayout = () => (
  <AuthProvider>
    <div className="min-h-screen bg-ivory" data-testid="admin-layout">
      <Outlet />
    </div>
  </AuthProvider>
);

export const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="grid min-h-screen place-items-center" data-testid="admin-checking">
        <p className="font-display text-2xl text-navy">Verifica accesso…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
